module.exports = "<div class=\"dialog select-file-dialog\">\n  <h2 mat-dialog-title>\n    <span class=\"message\">\n      <span *ngIf=\"!folders\">Select files in Aspera Client</span>\n      <span *ngIf=\"folders\">Select folders in Aspera Client</span>\n    </span>\n  </h2>\n  <mat-dialog-content>\n    <mat-icon class=\"aspera-client-icon\">cloud_upload</mat-icon>\n  </mat-dialog-content>\n  <mat-dialog-actions>\n    <button mat-button mat-dialog-close tabindex=\"-1\">Dismiss</button>\n  </mat-dialog-actions>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/select-file-dialog.component.html
// module id = ./src/app/shared/select-file-dialog.component.html
// module chunks = main